module.exports = __webpack_public_path__ + "img/icon_zoho.d597a749.svg";